import script from "./AttendancesList.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendancesList.vue?vue&type=script&setup=true&lang=js"

import "./AttendancesList.vue?vue&type=style&index=0&id=2df76bde&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df76bde"]])

export default __exports__